import { render, staticRenderFns } from "./DocumentationPanelTab.vue?vue&type=template&id=90b2eb42&scoped=true&"
import script from "./DocumentationPanelTab.vue?vue&type=script&lang=js&"
export * from "./DocumentationPanelTab.vue?vue&type=script&lang=js&"
import style0 from "./DocumentationPanelTab.vue?vue&type=style&index=0&id=90b2eb42&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b2eb42",
  null
  
)

export default component.exports